/**
 * Label de campo con icono (Typography sobre el input, patrón visual de formularios)
 */
import React from "react";
import { Typography } from "@mui/material";

const FieldLabel = ({ icon: Icon, children }) => (
    <Typography
        variant="body2"
        sx={{
            fontWeight: 600,
            mb: 1,
            color: "#495057",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
        }}
    >
        {Icon && <Icon sx={{ fontSize: 18 }} />}
        {children}
    </Typography>
);

export default FieldLabel;
